import { createRouter, createWebHashHistory, RouteRecordRaw } from 'vue-router'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'Home',
    component: () => import(/* webpackChunkName: "home" */ '../views/Home.vue')
  },
  {
    path: '/hall',
    name: 'Hall',
    component: () => import(/* webpackChunkName: "hall" */ '../views/Hall.vue')
  },
  // 讲师详情
  {
    path: '/speakers/:id',
    name: 'Speakers',
    component: () => import(/* webpackChunkName: "speakers" */ '../views/Speakers.vue')
  },
  {
    path: '/webview',
    name: 'Webview',
    component: () => import(/* webpackChunkName: "speakers" */ '../views/Webview.vue')
  },
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router
